import React from "react"

import starsImg from "../img/stars.png"
import lineBlue from "../img/overlays/method-outline-blue.svg"
import lineOrange from "../img/overlays/method-outline-orange.svg"

import "../style/metodologia.css"

function Metodologia() {
    return (
        <div className="metodologia-container">
            <img src={starsImg} alt="stars-img" className="stars-img" />
            <img src={lineBlue} className="ov blue" />
            <b>Metodologia HUG</b>
            <span className="text-element">A Metodologia HUG é um sistema próprio de desenvolvimento socioemocional, criado para apoiar pessoas, escolas e comunidades na construção de competências essenciais para a vida. <br /><br />Fundamentada em bases teóricas consolidadas, evidências científicas e práticas pedagógicas consistentes, organiza o desenvolvimento das Life Skills de forma contínua e integrada, respeitando as diferentes fases da vida e os contextos educacionais.</span>
            <img src={lineOrange} className="ov orange" />
            <a href="#">
                <svg xmlns="http://www.w3.org/2000/svg" width="350" viewBox="0 0 438 65" fill="none" className="bg">
                    <path d="M422.041 58.6385C286.74 65.928 151.088 65.928 15.787 58.6385C9.46422 58.281 2.77926 53.525 1.66203 48.1317C-0.55401 37.3399 -0.55401 26.7657 1.66203 15.974C2.77926 10.5807 9.46422 5.82979 15.787 5.46712C151.088 -1.82238 286.74 -1.82238 422.041 5.46712C428.364 5.82461 435.049 10.5807 436.166 15.974C438.382 26.7657 438.382 37.3399 436.166 48.1317C435.049 53.525 428.364 58.2758 422.041 58.6385Z" fill="#3498D4"/>
                </svg>
                <span>Conheça Nossa Metodologia</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="19" viewBox="0 0 28 19" fill="none" className="arrow">
                    <path d="M17.1713 17.9845C16.6269 17.4401 16.6269 16.5606 17.1713 16.0161L22.574 10.5855H1.39603C0.628206 10.5855 -1.52588e-05 9.95729 -1.52588e-05 9.18946C-1.52588e-05 8.42164 0.628206 7.79342 1.39603 7.79342H22.574L17.1574 2.37677C16.6129 1.83231 16.6129 0.952801 17.1574 0.408343C17.7018 -0.136114 18.5813 -0.136114 19.1258 0.408343L26.9436 8.21223C27.4881 8.75669 27.4881 9.6362 26.9436 10.1807L19.1398 17.9845C18.5953 18.515 17.7018 18.515 17.1713 17.9845Z" fill="white"/>
                </svg>
            </a>
        </div>
    )
}

export default Metodologia